import * as React from 'react';
import DocumentTitle from 'react-document-title';
import { withRouter } from 'react-router-dom';
import { parse } from 'query-string';
import { connect } from 'react-redux';
import { getUser } from '../reducers/userReducer';
import Routes from '../routes';
import ImageGalleryComponent from '../features/deliveredimagegallery/DeliveredImagesGalleryPage';
import { savePreviousLocation } from '../actions/RouterActions';
import { AuthenticatedUser } from '../shared/types';
import Header from './common/header/Header';
import { getSupportedDateLocal, Translate } from '../shared/LanguageService';
import ErrorBoundary from './errors/ErrorBoundary';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { UserProvider } from '../shared/context/user-context';
import { TranslationEditorProvider } from '../features/translationEditor/state/TranslationEditorContext';
import TranslationEditorScope from '../features/translationEditor/view/TranslationEditorScope';

class App extends React.Component<any, any> {
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            let excludeRegex = /\/orders\/\d+(\/(basic|video|image|plan|logs))?/;

            if (!excludeRegex.test(this.props.location.pathname)) {
                this.props.actions.savePreviousLocation(this.props.location.pathname);
            }
        }
    }

    render() {
        if (this.props.location.pathname === '/imagegallery') {
            const params = parse(this.props.location.search);
            return (
                <ErrorBoundary section="image_gallery" user={this.props.user}>
                    <ImageGalleryComponent reference={params.reference} />
                </ErrorBoundary>
            );
        }

        let standAloneViews = ['/'];
        let isStandAlone = standAloneViews.some((x) => x === this.props.location.pathname);

        if (isStandAlone) {
            return (
                <div>
                    <TranslationEditorScope>
                        <ErrorBoundary section="header" user={this.props.user}>
                            <Header />
                        </ErrorBoundary>
                        <ErrorBoundary section="content" user={this.props.user}>
                            <Routes />
                        </ErrorBoundary>
                    </TranslationEditorScope>
                </div>
            );
        }

        let fluidPaths = ['/se360/photographerbooking', '/calendars'];
        let isFluid = fluidPaths.some((x) => x === this.props.location.pathname);
        let isFluidFavorites = this.props.location.pathname.startsWith('/favorite-images');
        let containerClass = 'container';

        if (isFluid || isFluidFavorites) {
            containerClass += '-fluid';
        }

        return (
            <div>
                <TranslationEditorScope>
                    <ErrorBoundary section="header" user={this.props.user}>
                        <Header />
                    </ErrorBoundary>
                    <ErrorBoundary section="content" user={this.props.user}>
                        <div className={containerClass + ' page-body'}>
                            <Routes />
                            <div className="push" />
                        </div>
                    </ErrorBoundary>
                </TranslationEditorScope>
            </div>
        );
    }
}

function AppWithTitle(props) {
    let { site } = window.appConfig;
    let { languageKey } = props.user.details;
    let supportedLanguageKey = getSupportedDateLocal(languageKey);

    if (site === 'se360') {
        let productName = Translate('header/nav/product-name');
        return (
            <DocumentTitle title={`SE360 ${productName ? productName : ''}`}>
                <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={supportedLanguageKey}
                >
                    <UserProvider user={props.user}>
                        <App {...props} />
                    </UserProvider>
                </LocalizationProvider>
            </DocumentTitle>
        );
    }
    if (site === 'zentuvo') {
        let productName = Translate('header/nav/product-name');
        return (
            <DocumentTitle title={`Zentuvo ${productName ? productName : ''}`}>
                <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={supportedLanguageKey}
                >
                    <UserProvider user={props.user}>
                        <App {...props} />
                    </UserProvider>
                </LocalizationProvider>
            </DocumentTitle>
        );
    }

    return <App {...props} />;
}

function AppWithTranslationEditor(props) {
    return (
        <TranslationEditorProvider>
            <AppWithTitle {...props} />
        </TranslationEditorProvider>
    );
}

type ReduxProps = {
    user: AuthenticatedUser;
};

function mapStateToProps(state): ReduxProps {
    let user = getUser(state);
    return {
        user
    };
}

export default connect(mapStateToProps, (dispatch: any) => {
    return {
        actions: {
            savePreviousLocation: (previousLocation: string) => {
                dispatch(savePreviousLocation(previousLocation));
            }
        }
    };
})(withRouter(AppWithTranslationEditor));
